'use client';
import { useToast } from '@eliadmin/core/src/components/ui/use-toast';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { FacebookShareButton, TwitterShareButton, EmailShareButton } from 'next-share';
import React from 'react';
import { FaFacebookF, FaXTwitter, FaEnvelope, FaClipboard } from 'react-icons/fa6';

const ShareButton = ({ children, onClick }: { children: any; onClick?: () => void }) => {
  return (
    <div
      onClick={() => onClick?.()}
      className="group flex h-[52px] w-[52px] cursor-pointer items-center justify-center rounded-full bg-[hsl(var(--primary)/0.08)] transition-all duration-200 hover:bg-primary"
    >
      {React.cloneElement(children, {
        className: 'text-primary h-5 w-5 group-hover:text-white ',
      })}
    </div>
  );
};

export const BlogShare = () => {
  const { t } = useTranslations();
  const shareUrl = typeof window !== 'undefined' ? window.location.href : '';
  const { toast } = useToast();

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      toast({
        title: t('text1156'),
        variant: 'success',
      });
    });
  };

  return (
    <div className="flex w-full flex-col items-center justify-start gap-4 sm:flex-row">
      <p className=" text-lg font-bold">{t('text1155')}</p>
      <div className="flex items-center justify-start gap-2 md:gap-4">
        <FacebookShareButton url={shareUrl} className="flex max-w-min">
          <ShareButton>
            <FaFacebookF />
          </ShareButton>
        </FacebookShareButton>
        <TwitterShareButton url={shareUrl} className="flex max-w-min">
          <ShareButton>
            <FaXTwitter />
          </ShareButton>
        </TwitterShareButton>
        <EmailShareButton url={shareUrl} className="flex max-w-min">
          <ShareButton>
            <FaEnvelope />
          </ShareButton>
        </EmailShareButton>
        <ShareButton onClick={() => copyToClipboard()}>
          <FaClipboard />
        </ShareButton>
      </div>
    </div>
  );
};
